"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.results.title': 'Resultados del Entrenamiento',
    'trainer.results.success': '¡Entrenamiento Completado Exitosamente!',
    'trainer.results.success.message': 'Su modelo personalizado {modelName} ha sido entrenado y está listo para usar.',
    'trainer.results.metrics': 'Métricas de Rendimiento Final',
    'trainer.results.metric.loss': 'Pérdida Final',
    'trainer.results.metric.accuracy': 'Precisión Final',
    'trainer.results.metric.epochs': 'Épocas Completadas',
    'trainer.results.metric.samples': 'Muestras de Entrenamiento',
    'trainer.results.export': 'Exportar Modelo',
    'trainer.results.deploy': 'Desplegar Modelo',
    'trainer.results.test': 'Probar Modelo',
};
